const getBaseLayer = (state) => { return state.baseLayer }
const getBaseLayers = (state) => { return state.layersBase }
const getBasePk = (state) => { return state.basePk }
const getDraft = (state) => { return state.activeLayerId !== null ? state.layers[state.activeLayerId].draft : null }
const getLayerDraft = (state) => (layerId) => {
  const layer = state.layers[layerId]
  return layer ? layer.draft : null
}
const getTargetLayer = (state) => { return state.targetLayer }
const getTargetPk = (state) => { return state.targetPk }
const getGeoPopLevels = (state) => {
  return state.geoPopLevels
}
const getStyle = (state) => (id) => {
  const item = state.layerList.find(item => item.id === id)
  const layer = item.object.layer
  const dataVis = layer.jbData.config.datavis
  return dataVis.style
}
const getNewlayer = (state) => {
  return state.newLayer
}
const getStatusLayer = (state) => {
  return state.statusLayer
}

const getLoading = (state) => {
  return state.loading
}
const getLayersMenu = (state) => {
  return state.layersMenu
}

const getEnvironment = (state) => {
  return state.environment
}


export default {
  getDraft,
  getLayerDraft,
  getEnvironment,
  getLayersMenu,
  getBaseLayer,
  getBaseLayers,
  getBasePk,
  getGeoPopLevels,
  getLoading,
  getNewlayer,
  getStyle,
  getStatusLayer,
  getTargetLayer,
  getTargetPk
}
